export default "__VITE_ASSET__BHDFsj8e__"